import {
  addToaster,
  completeTaskByTaskIdApi,
  hideLoader,
  showLoader,
  updateWorkflowInstance,
  WORKFLOW_UI_IDENTIFIER,
  fetchFaxIdCorrespondingData,
  WorkflowInstanceTaskType,
  WorkflowTaskCompleteResponseType,
  interruptWorkFlow,
  EVENT_CONSTANTS,
  taskUpdateApi,
  getEntityDataByEntityNameIdApiForFilter,
  updateMaxRTEAutotriggered,
  changeTaskStatusToWithdraw,
  fetchCaptureApiResponse,
  getGenericEntityListingAPI,
} from '@app-store'
import { NAMESPACE, SelectDropDown } from '@ui-kit'
import {
  RootState,
  useAppDispatch,
  useAppSelector,
} from '../../utils/agent.store'
import { v4 as uuid } from 'uuid'
import { get, isEmpty } from 'lodash'
import { MISSING_INFO_CONSTANTS } from '../../constants/missingInfoModal.constants'
import {
  NAMESPACES,
  OUTBOUND_ID_CONSTANTS,
  WORKFLOW_STATUS,
} from '../../utils/constants'
import { isAxiosError } from 'axios'
import {
  logErrorMessage,
  startPollingForIntake,
  createVerbalConsentTranscriptOutboundTask,
  shouldPromptVerbalConsentTranscriptLetter,
} from '../../utils/helperFunctions'
import { useEffect, useState } from 'react'
import {
  getEntityData,
  getEntityDataByIdEmbedded,
  reportTemplateUsage,
} from '../../apis/entityData.api'
import moment from 'moment'
import { CaptureApiResponseProps } from '../../types/pap.types'
import { FieldValues } from 'react-hook-form'
import { STRINGS, VERBAL_CONSENT_STRINGS } from '../../utils/strings'
import AcceptConfirmModal from '../Modal/AcceptConfirmModal'

const WorkflowTaskStatus = ({
  task,
  taskId,
  status,
  reFetch,
  handleTaskResponse,
  tabIndex,
  isDisabled,
  recordId,
  handleSaveDetails,
  showToaster = false,
  overallCaseStatus,
}: {
  task: WorkflowInstanceTaskType
  taskId: string
  status: string
  reFetch: () => void
  fetchTasklist?: () => void
  handleTaskResponse?: (
    workflow: WorkflowTaskCompleteResponseType,
    isOpen: boolean,
    task?: WorkflowInstanceTaskType | null,
    resetTaskListData?: () => void
  ) => void
  tabIndex?: number
  isDisabled?: boolean
  recordId?: string
  handleSaveDetails?: (taskId: string) => Promise<boolean>
  showToaster?: boolean
  overallCaseStatus?: string
}) => {
  const dispatch = useAppDispatch()
  const [listData, setListData] = useState<{ value: string; label: string }[]>(
    []
  )
  const [isWorkflowInProgress, setIsWorkflowInProgress] =
    useState<boolean>(false)
  const [isTranscriptLetterModalOpen, setIsTranscriptLetterModalOpen] =
    useState(false)
  const taskStatus = status.charAt(0) + status.slice(1).toLowerCase()
  const workflowDefinition = useAppSelector(
    (state) => state?.workflowData?.workflowDefinition
  )
  const workflowInstance = useAppSelector(
    (state) => state?.workflowData?.workflowInstance
  )
  const WorkFlowTaskStatusData = useAppSelector(
    (state: RootState) => state.workflowTaskStatus?.workflowTaskStates
  )
  const workflowInstanceAdditionalKeys = useAppSelector(
    (state) => state?.workflowData?.workflowInstanceAdditionalKeys
  )
  const caseData = useAppSelector((state) => state?.workflowData?.caseData)
  const user = useAppSelector((state: RootState) => state?.authUser?.user)
  const taskDisableForTemplate =
    (task?.task_template?.id?.toString() === '9' ||
      task?.task_template?.id?.toString() === '11' ||
      task?.task_template?.id?.toString() === '7') &&
    status === WORKFLOW_STATUS.COMPLETED
  const getStatusMessage = (changeStatus: string) => {
    switch (changeStatus) {
      case WORKFLOW_STATUS.COMPLETED:
        return NAMESPACES.TASK_COMPLETED_SUCCESSFULLY
      case WORKFLOW_STATUS.PENDING:
        return NAMESPACES.TASK_PENDING_SUCCESSFULLY
      case WORKFLOW_STATUS.OPEN:
        return NAMESPACES.TASK_OPEN_SUCCESSFULLY
      case WORKFLOW_STATUS.CANCELLED:
        return NAMESPACES.TASK_CANCELLED_SUCCESSFULLY
      default:
        return NAMESPACES.UNKNOWN_MESSAGE
    }
  }
  const getFailureMessage = (changeStatus: string) => {
    switch (changeStatus) {
      case WORKFLOW_STATUS.COMPLETED:
        return NAMESPACES.SOMETHING_WENT_WRONG_TASK_COULD_NOT_BE_COMPLETED
      case WORKFLOW_STATUS.PENDING:
        return NAMESPACES.SOMETHING_WENT_WRONG_TASK_COULD_NOT_BE_PENDING
      case WORKFLOW_STATUS.OPEN:
        return NAMESPACES.SOMETHING_WENT_WRONG_TASK_COULD_NOT_BE_OPEN
      case WORKFLOW_STATUS.CANCELLED:
        return NAMESPACES.SOMETHING_WENT_WRONG_TASK_COULD_NOT_BE_CANCELLED
      default:
        return NAMESPACES.UNKNOWN_MESSAGE
    }
  }
  const fetchStatus = async (changeStatus: string) => {
    try {
      dispatch(showLoader())
      const responseStatus = await fetchFaxIdCorrespondingData(
        Number(task?.resource_id ?? '')
      )
      if (
        (responseStatus?.data && changeStatus === WORKFLOW_STATUS.COMPLETED) ||
        changeStatus !== WORKFLOW_STATUS.COMPLETED
        //  &&
        // responseStatus?.data?.category_status_id === 'SUCCESS'
      ) {
        completeTask(changeStatus)
      } else {
        setListData([...listData])
        dispatch(
          addToaster({
            message: NAMESPACES?.TASK_CANNOT_BE_COMPLETED,
            type: 'error',
            id: uuid(),
          })
        )
      }
    } catch (err) {
      logErrorMessage('task status', err)
      setListData([...listData])
      dispatch(
        addToaster({
          message: NAMESPACES?.TASK_CANNOT_BE_COMPLETED,
          type: 'error',
          id: uuid(),
        })
      )
    } finally {
      dispatch(hideLoader())
    }
  }
  const checkStatusCompleted = (
    task: WorkflowInstanceTaskType,
    changeStatus: string
  ) => {
    return task?.identifier?.validation && changeStatus === 'COMPLETED'
  }
  const futureDateCalculate = (
    createdAtStr: Date,
    dueDateStr: Date
  ): string => {
    const diffInDays = moment(dueDateStr)
      .startOf('day')
      .diff(moment(createdAtStr).startOf('day'), 'days')

    const futureDate = moment().startOf('day').add(diffInDays, 'days')

    return futureDate.format('YYYY-MM-DD')
  }
  const fetchStartDateTask = async (changeStatus: string) => {
    try {
      if (
        status === WORKFLOW_STATUS.PENDING &&
        changeStatus === WORKFLOW_STATUS.OPEN &&
        !task?.start_date
      )
        await taskUpdateApi(
          {
            taskId: task?.id ?? '',
            data: {
              start_date: new Date().toISOString().split('T')[0],
              due_date:
                task?.created_at && task?.due_date
                  ? futureDateCalculate(task?.created_at, task?.due_date)
                  : task?.due_date,
            },
          },
          caseData?.programs?.id?.toString(),
          caseData?.services?.id?.toString()
        )
    } catch (error) {
      logErrorMessage('taskUpdateError', error)
    }
  }
  const fetchSummaryId = async () => {
    try {
      const res = await getEntityDataByIdEmbedded(
        workflowDefinition?.global_variables?.entity_name ?? '',
        Number(workflowDefinition?.global_variables?.entity_id),
        ['case_summary'],
        recordId ?? ''
      )
      if (res?.data) {
        return res?.data?.case_summary?.id
      }
    } catch (err) {
      console.error(err)
    }
  }
  const fetchEntityData = async () => {
    try {
      const layoutId =
        workflowDefinition?.global_variables?.sub_sticky_summary?.layout_id ??
        workflowDefinition?.global_variables?.case_management?.close?.layout_id
      const entityId =
        workflowDefinition?.global_variables?.sub_sticky_summary?.entity_id ??
        workflowDefinition?.global_variables?.case_management?.close?.entity_id
      const summaryId = await fetchSummaryId()
      const response = await getEntityData(
        'case_summary',
        Number(entityId),
        Number(layoutId),
        summaryId
      )
      return response?.data
    } catch (err) {
      console.error(err)
    }
  }
  const checkStickySummaryData = async (changeStatus: string) => {
    const flag = false
    if (
      changeStatus === WORKFLOW_STATUS.COMPLETED &&
      task?.name === NAMESPACES.COMPLETE_CASE &&
      task?.identifier?.ui_identifier === WORKFLOW_UI_IDENTIFIER.NO_PREVIEW
    ) {
      const summaryData = await fetchEntityData()
      if (
        isEmpty(summaryData?.outcome_reason) ||
        isEmpty(summaryData?.outcome)
      ) {
        return !flag
      }
      return flag
    }
    return flag
  }

  const handleTrigger = () => {
    const event = new CustomEvent('triggerAddToAttachments', {
      detail: task,
    })
    window.dispatchEvent(event)
  }

  const resetTaskListData = () => {
    setListData([...listData])
  }

  const completeVerbalConsentTask = async () => {
    dispatch(showLoader())
    try {
      const res = await completeTaskByTaskIdApi({
        taskId: taskId,
        meta_data: {},
        forced: false,
        changeStatus: WORKFLOW_STATUS.COMPLETED,
      })

      dispatch(updateWorkflowInstance(res?.data?.instance))
      reFetch()
      dispatch(
        addToaster({
          message: getStatusMessage(WORKFLOW_STATUS.COMPLETED),
          type: 'success',
          id: uuid(),
        })
      )
    } catch (err: unknown) {
      let errorMessage = getFailureMessage(WORKFLOW_STATUS.COMPLETED)
      if (isAxiosError(err) && err.response?.data?.message) {
        errorMessage = err.response.data.message
      }
      setListData([...listData])
      dispatch(
        addToaster({
          message: errorMessage,
          type: 'error',
          id: uuid(),
        })
      )
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const handleVerbalConsentTranscriptYes = async () => {
    dispatch(showLoader())
    try {
      const processInstanceId = workflowInstance?.id
      const caseId = recordId ?? task?.case_id
      if (!processInstanceId || !caseId) {
        throw new Error('Missing process instance or case id')
      }
      await createVerbalConsentTranscriptOutboundTask({
        processInstanceId,
        caseId: String(caseId),
        assigneeId: user?.id,
      })
      setIsTranscriptLetterModalOpen(false)
      await completeVerbalConsentTask()
    } catch (createError) {
      console.error(createError)
      setListData([...listData])
      dispatch(
        addToaster({
          message: VERBAL_CONSENT_STRINGS.TRANSCRIPT_LETTER_CREATE_ERROR,
          type: 'error',
          id: uuid(),
        })
      )
    } finally {
      dispatch(hideLoader())
    }
  }

  const handleVerbalConsentComplete = async () => {
    try {
      dispatch(showLoader())
      if (!task?.resource_id) {
        setListData([...listData])
        dispatch(
          addToaster({
            message: NAMESPACES?.TASK_CANNOT_BE_COMPLETED,
            type: 'error',
            id: uuid(),
          })
        )
        return
      }

      const shouldPrompt = await shouldPromptVerbalConsentTranscriptLetter(
        task.resource_id
      )
      if (!shouldPrompt) {
        await completeVerbalConsentTask()
        return
      }

      setListData([...listData])
      setIsTranscriptLetterModalOpen(true)
    } catch (err) {
      console.error(err)
      setListData([...listData])
      dispatch(
        addToaster({
          message: NAMESPACES.SOMETHING_WENT_WRONG,
          type: 'error',
          id: uuid(),
        })
      )
    } finally {
      dispatch(hideLoader())
    }
  }

  const completeTask = async (changeStatus: string) => {
    dispatch(showLoader())
    try {
      let meta_data = {}
      const withdrawnTaskIdentifiers =
        task?.identifier?.layout_info?.sub_ui_identifier ===
          WORKFLOW_UI_IDENTIFIER.WITHDRAW_ENROLLMENT_TASK &&
        changeStatus === WORKFLOW_STATUS.COMPLETED
      let isPrerequisite = false
      if (
        !isEmpty(
          workflowDefinition?.definition?.steps?.[task.step_id ?? '']
            ?.preRequisite
        )
      ) {
        meta_data = {
          // TODO: might need later
          // entityId: task?.identifier?.entity_id,
          // layoutId: task?.identifier?.layout_info?.layout_id,
        }
        isPrerequisite = true
      }
      const dataForSummary = await checkStickySummaryData(changeStatus)
      if (dataForSummary) {
        dispatch(
          addToaster({
            message: NAMESPACES.CASE_SUMMARY_INCOMPLETE_TOASTER,
            type: 'error',
            id: uuid(),
          })
        )
        setListData([...listData])
        return
      }
      if (checkStatusCompleted(task, changeStatus)) {
        if (handleSaveDetails && changeStatus === 'COMPLETED') {
          const res = await handleSaveDetails(taskId)
          if (!res) {
            return
          }
        }
        const res = await completeTaskByTaskIdApi({
          taskId: taskId,
          meta_data,
          forced: false,
          changeStatus,
        })
        if (
          res?.status === 202 ||
          res?.data?.instance?.state ===
            WORKFLOW_STATUS.PROCESSING_IN_BACKGROUND
        ) {
          const poolingResponse: FieldValues = await startPollingForIntake({
            caseId: recordId ?? '',
          })
          res.data = {
            instance: poolingResponse?.workflow_instance,
            preRequisiteExecuted: isPrerequisite,
          }
          if (
            !isEmpty(poolingResponse?.workflow_instance?.background_response)
          ) {
            res.data.checkerResult =
              poolingResponse?.workflow_instance?.background_response ?? null
          }
        }
        if (
          (res.data.checkerResult?.data?.copay_status &&
            res?.data?.checkerResult?.data?.copay_status === 'FAILURE') ||
          (res.data.checkerResult &&
            res.data.checkerResult.status === 'FAILURE')
        ) {
          const newData = {
            taskId,
            ...res?.data,
          }
          await fetchStartDateTask(changeStatus)
          handleTaskResponse?.(newData, true, task, resetTaskListData)
          setListData([...listData])
        } else if (
          res?.data?.checkerResult?.data?.sp_triage_status === false ||
          res.data.checkerResult?.data?.pre_requisite_status === false
        ) {
          setListData([...listData])
          dispatch(
            addToaster({
              message:
                res?.data?.checkerResult?.data?.pharmacy_missing_message ??
                res?.data?.checkerResult?.data?.toaster_message,
              type: 'error',
              id: uuid(),
            })
          )
          return
        } else {
          const res = await completeTaskByTaskIdApi({
            taskId: taskId,
            meta_data,
            forced: true,
          })
          await fetchStartDateTask(changeStatus)
          if (!withdrawnTaskIdentifiers) reFetch()
          dispatch(updateWorkflowInstance(res?.data?.instance))
          dispatch(hideLoader())
          if (res?.data?.checkerResult?.data?.toaster_message) {
            dispatch(
              addToaster({
                message: res?.data?.checkerResult?.data?.toaster_message,
                type: 'warning',
                id: uuid(),
              })
            )
          } else {
            dispatch(
              addToaster({
                message: getStatusMessage(changeStatus),
                type: 'success',
                id: uuid(),
              })
            )
          }
        }
      } else {
        if (
          task?.identifier?.required_embedded_fields &&
          (task?.identifier?.ui_identifier ===
            WORKFLOW_UI_IDENTIFIER.ENTITY_LAYOUT ||
            task?.identifier?.ui_identifier ===
              WORKFLOW_UI_IDENTIFIER.SP_FILL_STATUS_RECORD ||
            task?.identifier?.ui_identifier ===
              WORKFLOW_UI_IDENTIFIER.SP_FILL_STATUS_RECORD_FOLLOW_UP) &&
          task?.resource_id &&
          changeStatus === WORKFLOW_STATUS.COMPLETED
        ) {
          const requiredFields = task.identifier.required_embedded_fields
          const selectFields: string[] = []
          const relatedEntities: Record<string, { select: string[] }> = {}

          for (const field of requiredFields) {
            const dotIndex = field.indexOf('.')
            if (dotIndex !== -1) {
              const parentKey = field.substring(0, dotIndex)
              const childKey = field.substring(dotIndex + 1)
              selectFields.push(parentKey)
              if (!relatedEntities[parentKey]) {
                relatedEntities[parentKey] = { select: [] }
              }
              relatedEntities[parentKey].select.push(childKey)
            } else {
              selectFields.push(field)
            }
          }
          const apiPayload = {
            payload: {
              entity_name: task?.identifier?.entity_name ?? '',
              page: 0,
              size: 1,
              select: selectFields,
              ...(Object.keys(relatedEntities).length > 0 && {
                related_entities: relatedEntities,
              }),
            },
          }
          const response = await getEntityDataByEntityNameIdApiForFilter(
            apiPayload,
            task?.resource_id
          )
          if (response?.data) {
            for (const field of requiredFields) {
              const dotIndex = field.indexOf('.')
              if (dotIndex !== -1) {
                const parentKey = field.substring(0, dotIndex)
                const childKey = field.substring(dotIndex + 1)
                const parentValue = get(response.data, parentKey)
                const hasAnyValue =
                  Array.isArray(parentValue) &&
                  parentValue.some((item) => {
                    const val = get(item, childKey)
                    return val !== null && val !== undefined && val !== ''
                  })
                if (!hasAnyValue) {
                  dispatch(
                    addToaster({
                      message: NAMESPACES.REQUIRED_TOAST,
                      type: 'error',
                      id: uuid(),
                    })
                  )
                  setListData([...listData])
                  return
                }
              } else {
                const value = get(response?.data, field)
                if (!value || value.length === 0) {
                  dispatch(
                    addToaster({
                      message: NAMESPACES.REQUIRED_TOAST,
                      type: 'error',
                      id: uuid(),
                    })
                  )
                  setListData([...listData])
                  return
                }
                setListData([...listData])
              }
            }
          }
        }
        if (handleSaveDetails && changeStatus === 'COMPLETED') {
          const res = await handleSaveDetails(taskId)
          if (!res) {
            return
          }
        }
        const res = await completeTaskByTaskIdApi({
          taskId: taskId,
          meta_data,
          forced: false,
          changeStatus,
        })

        if (
          res?.status === 202 ||
          res?.data?.instance?.state ===
            WORKFLOW_STATUS.PROCESSING_IN_BACKGROUND
        ) {
          const poolingResponse: FieldValues = await startPollingForIntake({
            caseId: recordId ?? '',
          })

          res.data = {
            instance: poolingResponse?.workflow_instance,
            preRequisiteExecuted: isPrerequisite,
          }
          if (
            !isEmpty(poolingResponse?.workflow_instance?.background_response)
          ) {
            res.data.checkerResult =
              poolingResponse?.workflow_instance?.background_response ?? null
          }
        }
        const isValid = res?.data?.checkerResult?.valid

        if (
          !isValid ||
          task?.identifier?.SHOW_MI_POPUP ||
          task?.identifier?.is_intake_layout
        ) {
          if (res?.data?.checkerResult && !res?.data?.checkerResult?.valid) {
            const newData = {
              taskId,
              ...res?.data,
            }
            handleTaskResponse?.(newData, true, task, resetTaskListData)
            setListData([...listData])
          } else {
            const res = await completeTaskByTaskIdApi({
              taskId: taskId,
              meta_data,
              forced: true,
              changeStatus,
            })
            if (!withdrawnTaskIdentifiers) reFetch()
            dispatch(updateWorkflowInstance(res?.data?.instance))
            if (res?.data?.checkerResult?.data?.toaster_message) {
              dispatch(
                addToaster({
                  message: res?.data?.checkerResult?.data?.toaster_message,
                  type: 'warning',
                  id: uuid(),
                })
              )
            } else {
              dispatch(
                addToaster({
                  message: getStatusMessage(changeStatus),
                  type: 'success',
                  id: uuid(),
                })
              )
            }
          }
          dispatch(hideLoader())
        } else {
          if (!withdrawnTaskIdentifiers) reFetch()
          dispatch(updateWorkflowInstance(res?.data?.instance))
          dispatch(hideLoader())
          if (res?.data?.checkerResult?.data?.toaster_message) {
            dispatch(
              addToaster({
                message: res?.data?.checkerResult?.data?.toaster_message,
                type: 'warning',
                id: uuid(),
              })
            )
          }

          dispatch(
            addToaster({
              message: getStatusMessage(changeStatus),
              type: 'success',
              id: uuid(),
            })
          )
        }
      }

      if (
        task?.identifier?.stopCurrentFlow &&
        changeStatus === WORKFLOW_STATUS.COMPLETED
      ) {
        const interruptResponse = await interruptWorkFlow({
          workflowId: workflowInstance?.id ?? '',
          signal: MISSING_INFO_CONSTANTS.STOPCURRENTFLOW,
        })

        if (interruptResponse?.data && !withdrawnTaskIdentifiers) {
          reFetch()
        }
      }
      sendEvent()
      if (
        task?.identifier?.ui_identifier ===
          WORKFLOW_UI_IDENTIFIER.GENERATE_DOCUMENT &&
        changeStatus === WORKFLOW_STATUS.COMPLETED
      ) {
        handleTrigger()
        task.resource_id && reportTemplateUsage(task.resource_id)
      }
      if (withdrawnTaskIdentifiers) {
        await changeTaskStatusToWithdraw(
          workflowInstance?.id ?? '',
          caseData?.programs?.id?.toString(),
          caseData?.services?.id?.toString()
        )
        reFetch()
      }
    } catch (err: unknown) {
      let errorMessage = getFailureMessage(changeStatus)

      if (isAxiosError(err) && err.response?.data?.message) {
        errorMessage = err.response.data.message
      }
      setListData([...listData])
      dispatch(
        addToaster({
          message: errorMessage,
          type: 'error',
          id: uuid(),
        })
      )

      dispatch(hideLoader())
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const OnTaskChange = async (changeStatus: {
    value: string
    label: string
  }) => {
    // todo
    // if (
    //   !task?.cancellable &&
    //   changeStatus?.value === WORKFLOW_STATUS.CANCELLED
    // ) {
    //   dispatch(
    //     addToaster({
    //       message: NAMESPACES?.TASK_CANNOT_BE_CANCELLED,
    //       type: 'info',
    //       id: uuid(),
    //     })
    //   )

    //   reFetch()
    //   return
    // }

    // TODO: commented to hide the extra loader
    // dispatch(showLoader())
    if (
      task?.identifier?.ui_identifier ===
        WORKFLOW_UI_IDENTIFIER?.SEND_COMMUNICATION_FAX ||
      task?.identifier?.ui_identifier ===
        WORKFLOW_UI_IDENTIFIER?.FAX_OUTBOUND_TASK
    ) {
      if (task?.resource_id) {
        fetchStatus(changeStatus?.value)
      } else if (
        (Number(task?.task_template?.id) !==
          OUTBOUND_ID_CONSTANTS.FAX_OUTBOUND_ID &&
          Number(task?.task_template?.id) !==
            OUTBOUND_ID_CONSTANTS.MAIL_OUTBOUND_ID &&
          changeStatus?.value === WORKFLOW_STATUS.COMPLETED) ||
        changeStatus?.value !== WORKFLOW_STATUS.COMPLETED
      ) {
        completeTask(changeStatus?.value)
      } else {
        setListData([...listData])
        dispatch(
          addToaster({
            message: NAMESPACES?.TASK_CANNOT_BE_COMPLETED,
            type: 'error',
            id: uuid(),
          })
        )
      }
    } else if (
      task?.identifier?.ui_identifier ===
      WORKFLOW_UI_IDENTIFIER.GENERATE_DOCUMENT
    ) {
      const isCompleteStatus = changeStatus.value === WORKFLOW_STATUS.COMPLETED
      if (task?.resource_id) {
        completeTask(changeStatus.value)
      } else if (isCompleteStatus) {
        setListData([...listData])
        dispatch(
          addToaster({
            message:
              NAMESPACES?.TASK_CANNOT_BE_COMPLETED_WITHOUT_GENERATING_DOC,
            type: 'error',
            id: uuid(),
          })
        )
      } else {
        completeTask(changeStatus.value)
      }
    } else if (
      task?.identifier?.ui_identifier === WORKFLOW_UI_IDENTIFIER?.GET_MAXRTE &&
      changeStatus?.value === WORKFLOW_STATUS?.PENDING
    ) {
      setListData([...listData])
      dispatch(
        addToaster({
          message: NAMESPACES?.COULD_NOT_MOVE_TO_PENDING,
          type: 'error',
          id: uuid(),
        })
      )
    } else if (
      task?.identifier?.ui_identifier === WORKFLOW_UI_IDENTIFIER?.GET_MAXRTE &&
      changeStatus?.value === WORKFLOW_STATUS?.COMPLETED
    ) {
      completeTask(changeStatus?.value)
      dispatch(updateMaxRTEAutotriggered(false))
    } else if (
      (task?.identifier?.ui_identifier ===
        WORKFLOW_UI_IDENTIFIER?.SYSTEM_CALL_OUTBOUND ||
        task?.identifier?.ui_identifier ===
          WORKFLOW_UI_IDENTIFIER?.MANUAL_CALL_OUTBOUND ||
        task?.identifier?.ui_identifier ===
          WORKFLOW_UI_IDENTIFIER?.SP_RELAY_CALL_OUTBOUND) &&
      changeStatus?.value === WORKFLOW_STATUS?.COMPLETED
    ) {
      if (task?.resource_id && task?.resource && task?.resource !== '') {
        completeTask(changeStatus?.value)
      } else {
        setListData([...listData])
        dispatch(
          addToaster({
            message:
              NAMESPACES?.PHONE_NUMBER_AND_NOTES_MANDATORY_FOR_TASK_COMPLETION,
            type: 'error',
            id: uuid(),
          })
        )
      }
    } else if (
      task?.identifier?.ui_identifier ===
        WORKFLOW_UI_IDENTIFIER?.PAP_CAPTURE_API_RESPONSE &&
      changeStatus?.value === WORKFLOW_STATUS?.COMPLETED
    ) {
      const response = await fetchCaptureAPIResponse()
      const finalData: CaptureApiResponseProps[] =
        response?.data?.content?.map((item: CaptureApiResponseProps) => ({
          ...item,
          attempt_count: item?.attempt_count?.toString(),
        })) || []
      if (
        finalData?.filter(
          (item) =>
            item?.status === NAMESPACE.SUCCESS_UPPERCASE ||
            item?.status === NAMESPACE.DELIVERED
        )?.length
      ) {
        completeTask(changeStatus?.value)
      } else {
        setListData([...listData])
        dispatch(
          addToaster({
            message: NAMESPACES?.TASK_CANNOT_BE_COMPLETED,
            type: 'error',
            id: uuid(),
          })
        )
      }
    } else if (
      task?.identifier?.ui_identifier ===
        WORKFLOW_UI_IDENTIFIER?.EPR_SELECT_LAYOUT &&
      changeStatus?.value === WORKFLOW_STATUS?.COMPLETED
    ) {
      const res = await fetchPharmacyData()
      if (res?.is_epr_retry_success && res?.pharmacy_id) {
        completeTask(changeStatus?.value)
      } else {
        setListData([...listData])
        dispatch(
          addToaster({
            message: NAMESPACES?.TASK_CANNOT_BE_COMPLETED_EPR,
            type: 'error',
            id: uuid(),
          })
        )
      }
    } else if (
      (task?.identifier?.ui_identifier ===
        WORKFLOW_UI_IDENTIFIER.SP_FILL_STATUS_RECORD ||
        task?.identifier?.ui_identifier ===
          WORKFLOW_UI_IDENTIFIER.SP_FILL_STATUS_RECORD_FOLLOW_UP) &&
      changeStatus?.value === WORKFLOW_STATUS.OPEN &&
      status === WORKFLOW_STATUS.COMPLETED
    ) {
      setListData([...listData])
      dispatch(
        addToaster({
          message: NAMESPACES.TASK_CANNOT_BE_REOPENED,
          type: 'error',
          id: uuid(),
        })
      )
    } else if (
      task?.identifier?.ui_identifier ===
        WORKFLOW_UI_IDENTIFIER.CAPTURE_VERBAL_CONSENT &&
      changeStatus?.value === WORKFLOW_STATUS.COMPLETED
    ) {
      await handleVerbalConsentComplete()
    } else {
      completeTask(changeStatus?.value)
    }
  }
  const fetchCaptureAPIResponse = async () => {
    try {
      dispatch(showLoader())
      const response = await fetchCaptureApiResponse(task?.identifier?.task_id)
      return response
    } catch (error) {
      console.error(error)
      return null
    } finally {
      dispatch(hideLoader())
    }
  }
  const fetchPharmacyData = async () => {
    try {
      dispatch(showLoader())
      const newPayload = {
        select: ['id', 'patient'],
        criteria: [],
        related_entities: {
          patient: {
            select: ['patient_pharmacy'],
            criteria: [],
            related_entities: {
              patient_pharmacy: {
                select: ['pharmacy_id', 'is_epr_retry_success', 'status'],
                filters: [
                  {
                    criteria: [
                      {
                        field_name: 'status',
                        operation: 'EQUALS',
                        values: ['ACTIVE'],
                      },
                    ],
                  },
                ],
              },
            },
          },
        },
        entity_name: workflowDefinition?.global_variables?.entity_name ?? '',
        entity_id: workflowDefinition?.global_variables?.entity_id ?? '',
      }

      const caseIdObject2 = await getGenericEntityListingAPI(
        newPayload,
        recordId ?? ''
      )
      const activeStatusData = caseIdObject2?.patient?.patient_pharmacy?.find(
        (item: FieldValues) => item?.status === 'ACTIVE'
      )
      return activeStatusData
    } catch (error) {
      console.log(error)
      return null
    } finally {
      dispatch(hideLoader())
    }
  }
  const sendEvent = () => {
    const taskCompleteEvent = new CustomEvent(
      EVENT_CONSTANTS?.TASK_COMPLETE_REFETCH_SUMMARY,
      {}
    )
    window.dispatchEvent(taskCompleteEvent)
  }

  const getFormattedTransitions = () => {
    const transitionData = WorkFlowTaskStatusData?.find(
      (s) => s?.state === status
    )
    if (
      !transitionData ||
      !Array.isArray(transitionData?.transitions) ||
      !transitionData?.transitions?.length ||
      isDisabled ||
      taskDisableForTemplate
    ) {
      return []
    }
    const finalData = [...transitionData.transitions]
      .sort((a, b) => a?.order - b?.order)
      .map((t) => ({
        label: t?.label,
        value: t?.state,
      }))
    if (task?.identifier?.ui_identifier === NAMESPACES.RE_VALIDATE) {
      return finalData?.filter(
        (val) =>
          val?.value !== WORKFLOW_STATUS.COMPLETED &&
          val?.value !== WORKFLOW_STATUS.CANCELLED
      )
    }
    if (
      task?.identifier?.ui_identifier ===
        WORKFLOW_UI_IDENTIFIER.SP_FILL_STATUS_RECORD &&
      status === WORKFLOW_STATUS.COMPLETED
    ) {
      return []
    }
    if (!task?.cancellable) {
      return finalData?.filter(
        (val) => val?.value !== WORKFLOW_STATUS.CANCELLED
      )
    }
    // TODO backend support in cancellationType
    // if (
    //   task?.cancellationType !== NAMESPACES.USER &&
    //   task?.cancellationType !== null &&
    //   status === WORKFLOW_STATUS.CANCELLED
    // ) {
    //   return finalData?.filter((val) => val?.value !== WORKFLOW_STATUS.OPEN)
    // }
    return finalData
  }
  const backgroundColorString = () => {
    switch (status) {
      case WORKFLOW_STATUS.PENDING:
        return 'bg-taskStatus-300'
      case WORKFLOW_STATUS.COMPLETED:
        return 'bg-taskStatus-200'
      case WORKFLOW_STATUS.CANCELLED:
        return 'bg-taskStatus-100'
      case WORKFLOW_STATUS.OPEN:
        return 'bg-secondary-25'
    }
  }
  useEffect(() => {
    if (WorkFlowTaskStatusData) {
      const listData = getFormattedTransitions()
      setListData(listData)
    }
  }, [WorkFlowTaskStatusData, taskStatus, workflowInstance, isDisabled])

  useEffect(() => {
    if (!isEmpty(workflowInstance)) {
      if (
        workflowInstance?.state === WORKFLOW_STATUS.PROCESSING_IN_BACKGROUND ||
        workflowInstanceAdditionalKeys?.background_jobs_active ||
        workflowInstanceAdditionalKeys?.isPolling
      ) {
        setIsWorkflowInProgress(true)
      } else {
        setIsWorkflowInProgress(false)
      }
    }
  }, [workflowInstance, workflowInstanceAdditionalKeys])

  useEffect(() => {
    if (showToaster) {
      dispatch(
        addToaster({
          message: NAMESPACES.TRIAGE_FORM_MERGING_IN_PROGRESS,
          type: 'success',
          id: uuid(),
        })
      )
    }
  }, [showToaster])
  return task?.identifier?.sub_ui_identifier === 'PAP_BV_CASE_TASK' &&
    overallCaseStatus !== STRINGS.VOID &&
    task?.state !== WORKFLOW_STATUS.COMPLETED ? (
    <div className="flex items-center w-full">
      <button
        type="button"
        className=" border rounded-md px-3 ml-3 bg-primary-500 text-white"
        onClick={(e) => {
          e?.stopPropagation()
          reFetch?.()
        }}
      >
        Reload
      </button>
    </div>
  ) : (
    <>
      <button
        type="button"
        className="flex w-full text-start"
        onClick={(e) => e?.stopPropagation()}
        disabled={
          (isWorkflowInProgress &&
            task?.identifier?.ui_identifier !==
              WORKFLOW_UI_IDENTIFIER.PAP_CAPTURE_API_RESPONSE) ||
          task?.identifier?.sub_ui_identifier === 'PAP_BV_CASE_TASK'
        }
      >
        <SelectDropDown
          height="h-[0.8rem]"
          label=""
          placeholder={taskStatus}
          options={listData}
          name="task_status"
          onChange={OnTaskChange}
          className={`text-xs ${backgroundColorString()}  ${
            isDisabled || taskDisableForTemplate ? ' cursor-not-allowed' : ''
          }`}
          tabIndex={tabIndex}
          isCrossable={false}
          isBordered={!isDisabled}
          customPadding="!px-1"
          key={taskStatus}
          disabled={
            (isWorkflowInProgress &&
              task?.identifier?.ui_identifier !==
                WORKFLOW_UI_IDENTIFIER.PAP_CAPTURE_API_RESPONSE) ||
            task?.identifier?.sub_ui_identifier === 'PAP_BV_CASE_TASK'
          }
        />
      </button>
      <AcceptConfirmModal
        isOpen={isTranscriptLetterModalOpen}
        closeModal={() => {
          setIsTranscriptLetterModalOpen(false)
          void completeVerbalConsentTask()
        }}
        onYesClick={() => {
          void handleVerbalConsentTranscriptYes()
        }}
        deleteMessage={VERBAL_CONSENT_STRINGS.TRANSCRIPT_LETTER_CONFIRM}
      />
    </>
  )
}
export default WorkflowTaskStatus
